import { StepNumber } from './stepper.type';

export enum StepperCategoryState {
  DEFAULT = 0,
  COMPLETED = 1,
  ERROR = 2,
  WARNING = 3,
  SELECTED = 4
}

export type StepConfig = {
  step: StepNumber;
  title: string;
  state: StepperCategoryState;
  customIsDisabled?: boolean;
};
